import { render } from "./ProductMoveMentAllMonth.vue?vue&type=template&id=0f508cf6&scoped=true"
import script from "./ProductMoveMentAllMonth.vue?vue&type=script&lang=js"
export * from "./ProductMoveMentAllMonth.vue?vue&type=script&lang=js"

import "./ProductMoveMentAllMonth.vue?vue&type=style&index=0&id=0f508cf6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f508cf6"

export default script